import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Button, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import ContactSupportButton from '~/components/ContactSupportButton';
import { useLocaleKeys } from '~/i18n';
import styles from '../ChangeEmailAddress.module.scss';
export const GetManyAttemptsErrorTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            ManyAttemptsErrorTID: {
                Root: 'many-attempts-error',
                ErrorMessage: 'error-message',
                ContactSupportButton: 'contact-support-button',
                CloseButton: 'close-button'
            }
        }
    });
const ManyAttemptsError = (param)=>{
    let { onClose } = param;
    const { t: changeEmailModalTexts } = useLocaleKeys('components.changeEmailModal');
    const { ManyAttemptsErrorTID } = useMemo(()=>GetManyAttemptsErrorTID(), []);
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": ManyAttemptsErrorTID.Root(),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.content,
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        testId: ManyAttemptsErrorTID.ErrorMessage(),
                        children: changeEmailModalTexts.tooManyAttempts()
                    }),
                    /*#__PURE__*/ _jsxs(Typography, {
                        children: [
                            changeEmailModalTexts.tryAgainLaterOr(),
                            ' ',
                            /*#__PURE__*/ _jsx(ContactSupportButton, {
                                testId: ManyAttemptsErrorTID.ContactSupportButton(),
                                underline: "none"
                            }),
                            "."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.footer,
                children: /*#__PURE__*/ _jsx(Button, {
                    bi: {
                        name: 'close_change_email_too_many_attempts'
                    },
                    onClick: onClose,
                    skin: "primaryOutline",
                    testId: ManyAttemptsErrorTID.CloseButton(),
                    children: changeEmailModalTexts.closeButton()
                })
            })
        ]
    });
};
export default ManyAttemptsError;
